// AnalyticsSkuViewed cloneElements its direct child to attach an intersection observer ref.
// The <TableRow> must be created in a client context — RSC-serialized elements fail with cloneElement.
'use client';

import { c as _c } from "react/compiler-runtime";
import type { CreditCardOffer } from '@cc-shopping/contracts/cross-site/marketplace/types';
import { TableRow } from '@mui/material';
import type { ReactNode } from 'react';
import { ExperimentOfferProvider } from 'src/shared/providers/ExperimentOfferContext';
import { FilterAwareSkuViewed } from './FilterAwareSkuViewed';
type SummaryTableAnalyticsOffer = Pick<CreditCardOffer, 'id' | 'name' | 'institution' | 'product'> & {
  details: Pick<CreditCardOffer['details'], 'isMonetizing' | 'directApplyLink' | 'monetizable'>;
  legacyAnalyticsOfferId?: string;
};
type SummaryTableAnalyticsWrapperProps = {
  index: number;
  creditCardOffer: SummaryTableAnalyticsOffer;
  eligibleForNWPlus: boolean;
  direction?: 'horizontal' | 'vertical';
  children: ReactNode;
  scrollableAncestor?: HTMLElement;
  impressionSectionName?: string;
  disableMonetization?: boolean;
  overrideSkuImpressionId?: string;
};
export const SummaryTableAnalyticsWrapper = t0 => {
  const $ = _c(25);
  const {
    index,
    creditCardOffer,
    eligibleForNWPlus,
    direction,
    children,
    scrollableAncestor,
    impressionSectionName,
    disableMonetization,
    overrideSkuImpressionId
  } = t0;
  let t1;
  if ($[0] !== creditCardOffer.details.directApplyLink || $[1] !== creditCardOffer.details.isMonetizing || $[2] !== creditCardOffer.id || $[3] !== creditCardOffer.institution || $[4] !== creditCardOffer.product) {
    t1 = {
      offerId: creditCardOffer.id,
      isMonetizing: creditCardOffer.details.isMonetizing,
      directApplyLink: creditCardOffer.details.directApplyLink,
      institution: creditCardOffer.institution,
      product: creditCardOffer.product
    };
    $[0] = creditCardOffer.details.directApplyLink;
    $[1] = creditCardOffer.details.isMonetizing;
    $[2] = creditCardOffer.id;
    $[3] = creditCardOffer.institution;
    $[4] = creditCardOffer.product;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== eligibleForNWPlus) {
    t2 = {
      nw_plus_eligible: eligibleForNWPlus
    };
    $[6] = eligibleForNWPlus;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = impressionSectionName ?? "roundup_summary_table";
  const t4 = disableMonetization ? "no" : creditCardOffer.details.monetizable;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      position: "relative"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children) {
    t6 = <TableRow component="tr" sx={t5}>{children}</TableRow>;
    $[9] = children;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== creditCardOffer.legacyAnalyticsOfferId || $[12] !== creditCardOffer.name || $[13] !== direction || $[14] !== index || $[15] !== overrideSkuImpressionId || $[16] !== scrollableAncestor || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t6) {
    t7 = <FilterAwareSkuViewed additionalAttributes={t2} direction={direction} id={creditCardOffer.legacyAnalyticsOfferId} impressionSection={t3} impressionPosition={index} monetizable={t4} name={creditCardOffer.name} offerId={creditCardOffer.legacyAnalyticsOfferId} scrollableAncestor={scrollableAncestor} overrideSkuImpressionId={overrideSkuImpressionId}>{t6}</FilterAwareSkuViewed>;
    $[11] = creditCardOffer.legacyAnalyticsOfferId;
    $[12] = creditCardOffer.name;
    $[13] = direction;
    $[14] = index;
    $[15] = overrideSkuImpressionId;
    $[16] = scrollableAncestor;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t1 || $[23] !== t7) {
    t8 = <ExperimentOfferProvider value={t1}>{t7}</ExperimentOfferProvider>;
    $[22] = t1;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};